import React from 'react';
import GreenLeafApi from '../utils/GreenLeafApi';
import ItemList from '../ItemList';
import {Button, Clearfix, Panel} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import ErrorComponent from '../ErrorComponent';


class AssessmentsPage extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      assessments: [],
      error: null
    };
    this.fetchAssessments = this.fetchAssessments.bind(this);
  }

  componentDidMount() {
    try {
      this.fetchAssessments();
    } catch (e) {
      this.setState({error: e.errors});
    }
  }

  async fetchAssessments() {
    const assessments = await GreenLeafApi.Assessment.find();
    this.setState({assessments: assessments.data});
  }

  createAssessment() {
    this.props.history.push('/assessments/create');
  }

  render() {
    return(
      <div>
        <ErrorComponent error={this.state.error}/>
        <Panel>
          <Panel.Heading>
            <Panel.Title data-cy="assessments-panel" componentClass="h3" className='relative flex-row'>
              <div>Assessments</div>
              <div className={'ml-auto'}>
                <Link to={'/assessments/create'}>
                  <Button data-cy="create-assessment" className={'primary'}>Create</Button>
                </Link>
              </div>
              <Clearfix/>
            </Panel.Title>

          </Panel.Heading>
          <Panel.Body>
            <ItemList options={{tableData: ['name'], tableHeaders: ['Assessment Name']}} items={this.state.assessments}/>
          </Panel.Body>
        </Panel>
      </div>
    );
  }


}

export default AssessmentsPage;


// WEBPACK FOOTER //
// ./src/components/assessments/AssessmentsPage.js